import { Button, Inline, Stack } from "@sembark-travel/ui-base"
import {
	Form,
	SubmissionError,
	TextInputField,
	validateFormValues,
	withServerErrors,
} from "@sembark-travel/ui-form"
import { useXHR } from "@sembark-travel/xhr"
import { useMemo } from "react"
import { Optional } from "utility-types"
import * as Validator from "yup"
import { IDocGroup } from "./store"

export function NewDocumentTypeItem({
	onSuccess,
	onCancel,
	initialValues,
}: {
	onSuccess: (tripSource: IDocGroup) => void
	onCancel?: () => void
	initialValues?: { name: string }
}) {
	const xhr = useXHR()
	return (
		<NewItemForm
			onCancel={onCancel}
			onSubmit={async (values: NewDocumentTypeItemValues) => {
				const doc = await xhr.post("/document-types", values)
				onSuccess(doc.data.data)
				return doc
			}}
			initialValues={initialValues}
		/>
	)
}

const validationSchema = Validator.object().shape({
	name: Validator.string().required("Please provide name for the Document"),
})

type NewDocumentTypeItemValues = {
	name: string
}

export function NewItemForm({
	onSubmit,
	onCancel,
	initialValues: propInitialValues,
}: {
	onSubmit: (data: NewDocumentTypeItemValues) => Promise<unknown>
	onCancel?: () => void
	initialValues?: Optional<NewDocumentTypeItemValues>
}) {
	const initialValues = useMemo(() => {
		return {
			name: propInitialValues?.name || "",
		}
	}, [propInitialValues])

	return (
		<Form<NewDocumentTypeItemValues>
			initialValues={initialValues}
			validate={validateFormValues(validationSchema)}
			onSubmit={withServerErrors(async (values) => {
				await onSubmit(values)
			})}
			subscription={{ submitting: true }}
		>
			{({ submitting, handleSubmit }) => (
				<form noValidate onSubmit={handleSubmit}>
					<Stack gap="4">
						<TextInputField
							label="Name"
							name="name"
							type="text"
							placeholder="e.g. Govt. ID"
							required
						/>
						<SubmissionError />
						<Inline gap="4">
							<Button type="submit" disabled={submitting}>
								{submitting ? "Saving..." : "Save Details"}
							</Button>
							{onCancel ? (
								<Button onClick={onCancel} level="tertiary">
									Cancel
								</Button>
							) : null}
						</Inline>
					</Stack>
				</form>
			)}
		</Form>
	)
}
